import { faCheck, faUndo } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Input } from "../../components/Input"
import { Load } from "../../components/Load"
import { ICidades } from "../../global/types"
import { useAdmContext } from "../../hooks/useAdmContext"
import { api } from "../../services/api"
import "./style.css"

type ParamsProps = {
  tipo: "new" | "edit"
}

type IParams = {
  id: string
}

export function CidadesForm({ tipo }: ParamsProps) {
  const navigate = useNavigate()

  const { id } = useParams() as IParams
  const { tokens, checkToken } = useAdmContext()

  const [loading, setLoading] = useState(false)
  const [txtLoading, setTxtLoading] = useState("")

  const [cadastro, setCadastro] = useState<ICidades>({} as ICidades)

  const loadCadastro = useCallback(async () => {
    setLoading(true)
    setTxtLoading("Carregando cadastro...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    await api.get(`cidades/${id}`)
      .then((res) => {
        if (!res.data)
          return

        const cad = res.data as ICidades

        setCadastro({ ...cad })
      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert("Erro ao carregar o cadastro. Tente novamente mais tarde")
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }, [checkToken, id])

  const handleSalvar = async () => {
    setLoading(true)
    setTxtLoading("Salvando...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    try {
      await api.post("cidades", {
        ...cadastro
      })

      navigate("/cidades")
    } catch (err: any) {
      if (err.response?.data?.message)
        alert(err.response?.data?.message);
      else
        alert("Erro ao salvar. Tente novamente mais tarde.");

      setLoading(false);
      setTxtLoading("");
    }
  }

  useEffect(() => {
    if (tokens?.token && tipo === "edit")
      loadCadastro()
  }, [tokens, tipo, loadCadastro])

  return (
    <div id="pgCidadeForm">

      {loading && (
        <Load txtLoading={txtLoading} />
      )}

      {!loading && (
        <>
          <div className="painel form">
            <p className="title">{tipo === "new" ? "Novo" : "Editando"} Cadastro</p>

            <span style={{ width: "100%" }}>
              <label>Nome</label>
              <Input
                mask="none"
                value={cadastro.nome}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, nome: v }))}
                placeholder="Nome"
              />
            </span>

          </div>

          <div className="btnPainel">
            <button className="btn-purple" onClick={() => { navigate(-1) }}>
              <FontAwesomeIcon icon={faUndo} />
              VOLTAR
            </button>

            <button className="btn-green" onClick={() => { handleSalvar() }}>
              <FontAwesomeIcon icon={faCheck} />
              SALVAR
            </button>
          </div>
        </>
      )}


    </div>
  )
}